import {useLocation} from "react-router";

/**
 * Returns singleConfirmedRoute object from routes state
 */
export default function useSingleConfirmedRoute() {
    const {state} = useLocation()

    return state?.singleConfirmedRoute ?? null
}